import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28d23a66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "no-mb",
  style: {"line-height":"2"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryEntityRow',
  props: {
  label: String,
  entity: Object
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "delivery-entity-row no-mb" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 8}
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(props.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _createTextVNode(_toDisplayString(__props.entity.name), 1),
            _hoisted_2,
            _createTextVNode(_toDisplayString(__props.entity.address), 1),
            _hoisted_3,
            _createTextVNode(_toDisplayString(__props.entity.zipcode) + " " + _toDisplayString(__props.entity.city), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})